/* tslint:disable */
/* eslint-disable */
/**
 * Metaform REST API
 * REST API for Metaform
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MetaformFieldSourceOptions
 */
export interface MetaformFieldSourceOptions {
    /**
     * Source autocomplete field name. This option is used only when using source type autocomplete
     * @type {string}
     * @memberof MetaformFieldSourceOptions
     */
    autocompleteField?: string;
    /**
     * Name of the autocomplete item property to be used as field value. This option is used only when using source type autocomplete
     * @type {string}
     * @memberof MetaformFieldSourceOptions
     */
    autocompleteItemProperty?: string;
    /**
     * Name of the user token attribute. This option is used only when using source type accessToken
     * @type {string}
     * @memberof MetaformFieldSourceOptions
     */
    accessTokenAttribute?: string;
}

export function MetaformFieldSourceOptionsFromJSON(json: any): MetaformFieldSourceOptions {
    return MetaformFieldSourceOptionsFromJSONTyped(json, false);
}

export function MetaformFieldSourceOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): MetaformFieldSourceOptions {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'autocompleteField': !exists(json, 'autocompleteField') ? undefined : json['autocompleteField'],
        'autocompleteItemProperty': !exists(json, 'autocompleteItemProperty') ? undefined : json['autocompleteItemProperty'],
        'accessTokenAttribute': !exists(json, 'accessTokenAttribute') ? undefined : json['accessTokenAttribute'],
    };
}

export function MetaformFieldSourceOptionsToJSON(value?: MetaformFieldSourceOptions | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'autocompleteField': value.autocompleteField,
        'autocompleteItemProperty': value.autocompleteItemProperty,
        'accessTokenAttribute': value.accessTokenAttribute,
    };
}


